import * as Style from "./StyledDepartmentCourse";
import React from "react";
import * as Images from "../../../../images";
import { useModalContext } from "../../../../Provider/ModalProvider";
import { Link, useParams } from "react-router-dom";
import UseGetData from "../../../../HookAxios/getdata";
import { GET_REQUEST } from "../../../../HooksApi/useApi";
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonBase, CircularProgress } from "@mui/material";
import * as partS from "../../AboutCourse/redux/actions";
import Dots from "../../../../Components/Loader/Dots";
import Tooltip from "@mui/material/Tooltip";
import { Box } from "@mui/material";

import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { PurchaseConfirmationModal } from "./PurchaseConfirmationModal";

const DepartmentCourse = ({ data, loader }) => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = React.useState("");
  const { idCourse } = useParams();
  const token = useSelector((state) => state.Auth.userInfo.token);
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const {
    isLoading: LoadPart,
    data: dataPart,
    refetch: refetchSessions,
  } = GET_REQUEST({
    queryKey: `CoursePart${expanded}`,
    request: () =>
      UseGetData(
        "get_sessions_by_section_id",
        { id: expanded },
        { Authorization: `Bearer ${token}` }
      ),
    enabled: false,
  });

  React.useEffect(() => {
    if (!LoadPart && dataPart?.data?.data?.videos) {
      dispatch(partS.GetSessionsByCourse(dataPart?.data?.data?.videos));
    }
  }, [LoadPart]);
  React.useEffect(() => {
    if (expanded !== "" && expanded) refetchSessions();
  }, [expanded]);

  const { openLockedAcsses, openLogin } = useModalContext();

  const [open, setOpen] = React.useState(false);
  const [sectionName, setSectionName] = React.useState("");
  const [secionCost, setSectionCost] = React.useState(0);
  const [sectionId, setSectionId] = React.useState(0);

  const purchaseHandler = (e, { name, session_count, id }) => {
    e.stopPropagation();
    if (!token) {
      openLogin();
    } else {
      setOpen((prv) => !prv);
      setSectionName(name);
      setSectionCost(session_count);
      setSectionId(id);
    }
  };

  return (
    <Style.Section>
      {!loader && data ? (
        data.data.data.sections.map((el) => (
          <Style.Accordion
            key={el.id}
            expanded={expanded === el.id}
            onChange={handleChange(el.id)}
          >
            <Style.AccordionSummary>
              <Style.AccordionContent>
                <Style.AccordionContentText>
                  {/* <Style.Icon src={Images.LockOutline} alt="" /> */}
                  <Style.AccordionText>{el.name}</Style.AccordionText>
                </Style.AccordionContentText>

                <Style.AccordionContentText>
                  {expanded !== el.id && (
                    <>
                      <Style.Icon src={Images.WatchOutline} alt="" />
                      <Style.AccordionTextDetails>
                        {el.duration < 1
                          ? `${Math.ceil(el.duration * 60)} ثانية`
                          : el.duration < 60
                          ? `${Math.ceil(el.duration)} دقيقة`
                          : `${Math.ceil(el.duration / 60)} ساعة`}
                      </Style.AccordionTextDetails>
                      <Style.AccordionTextDetails>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <LocalOfferOutlinedIcon sx={{ color: "#808080" }} />
                          {el.cost} نقطة
                        </div>
                      </Style.AccordionTextDetails>
                      {!el.is_subscribtion ? (
                        <Button
                          sx={{ py: 0, position: "relative", zIndex: "100" }}
                          variant="contained"
                          size="small"
                          onClick={(e) =>
                            purchaseHandler(e, {
                              name: el.name,
                              session_count: el.cost,
                              id: el.id,
                            })
                          }
                        >
                          شراء
                        </Button>
                      ) : null}
                    </>
                  )}
                </Style.AccordionContentText>
              </Style.AccordionContent>

              {/* <button>button1</button> */}
            </Style.AccordionSummary>

            {/* <p> {el.id}</p> */}

            <Style.AccordionDetails>
              {!LoadPart && dataPart ? (
                <>
                  {dataPart.data.data.videos.map((element) => (
                    <Style.AccordionContentVed
                      key={element.id}
                      component={
                        element?.is_public ||
                        (!element.is_public && element.is_subscribtion)
                          ? Link
                          : ButtonBase
                      }
                      style={{ width: "100%" }}
                      onClick={
                        element?.is_public ||
                        (!element.is_public && element.is_subscribtion)
                          ? ""
                          : openLockedAcsses
                      }
                      to={`/course-description/${idCourse}/${el.id}/${element.id}`}
                    >
                      <Style.AccordionContentVedItems>
                        {element?.is_public ||
                        (!element.is_public && element.is_subscribtion) ? (
                          <Style.Icon src={""} alt="" />
                        ) : (
                          <Style.Icon src={Images.LockOutline} alt="" />
                        )}
                        <Style.AccordionText sx={{ fontSize: "14px" }}>
                          {element.Title}
                        </Style.AccordionText>
                      </Style.AccordionContentVedItems>

                      <Style.AccordionContentVedItems
                        sx={{
                          display: "grid",
                          gridTemplateColumns: " 1fr auto",
                          gap: "22px",
                        }}
                      >
                        {element.quiz_subscribtion ? (
                          <Link
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            to={`/testCourse/${element.id}`}
                          >
                            <Tooltip title="تقديم اختبار">
                              <QuizIcon />
                            </Tooltip>
                          </Link>
                        ) : null}

                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <Style.Icon src={Images.WatchOutline} alt="" />
                          <Style.AccordionText sx={{ fontSize: "14px" }}>
                            {element.duration < 1
                              ? `${Math.ceil(element.duration * 60)} ثانية`
                              : element.duration < 60
                              ? `${Math.ceil(element.duration)} دقيقة`
                              : `${Math.ceil(element.duration / 60)} ساعة`}
                          </Style.AccordionText>
                        </Box>
                      </Style.AccordionContentVedItems>
                    </Style.AccordionContentVed>
                  ))}
                  {el.quiz && (
                    <Style.AccordionContentVed
                      component={
                        // el?.is_public || !el.is_public && el.is_subscribtion ?
                        Link
                        // : ButtonBase
                      }
                      style={{ width: "100%" }}
                      //  onClick={el?.is_public || !el.is_public && el.is_subscribtion ? '' : openLockedAcsses}
                      to={`/test-unit/${el.id}`}
                    >
                      <Style.AccordionContentVedItems>
                        {/* {
                                                            el?.is_public || !el.is_public && el.is_subscribtion ?
                                                                <Style.Icon src={''} alt="" />

                                                                :
                                                                <Style.Icon src={Images.LockOutline} alt="" />
                                                        } */}
                        {el.is_subscribtion ? (
                          <Style.AccordionText sx={{ fontSize: "14px" }}>
                            اختبار الوحدة
                          </Style.AccordionText>
                        ) : null}
                      </Style.AccordionContentVedItems>
                      <Style.AccordionContentVedItems>
                        {/* <Style.Icon src={Images.WatchOutline} alt="" /> */}
                        {/* <Style.AccordionText sx={{ fontSize: '14px' }}>
                                                    </Style.AccordionText> */}
                      </Style.AccordionContentVedItems>
                    </Style.AccordionContentVed>
                  )}
                </>
              ) : (
                <center>
                  {" "}
                  <CircularProgress
                    sx={{ alignSelf: "center", width: "8px" }}
                  />
                </center>
              )}
            </Style.AccordionDetails>
          </Style.Accordion>
        ))
      ) : (
        <Dots />
      )}
      <PurchaseConfirmationModal
        open={open}
        setOpen={setOpen}
        sectionName={sectionName}
        secionCost={secionCost}
        sectionId={sectionId}
        courseId={idCourse}
      />
    </Style.Section>
  );
};

export default DepartmentCourse;

const QuizIcon = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5119 12.1521C13.456 12.0685 13.3726 11.9845 13.2891 11.9009C13.0379 11.9565 12.7876 11.9845 12.508 11.9845C12.7876 12.1521 13.0379 12.4027 13.2057 12.6816V12.7096C13.4835 13.1278 13.5394 13.6016 13.4835 14.0472C13.4285 14.354 13.3167 14.6329 13.1498 14.8835C12.9829 15.1341 12.7592 15.3574 12.4805 15.4967C12.0908 15.7479 11.6453 15.8312 11.1145 15.7479C10.7248 15.6919 10.3618 15.4967 10.0839 15.2461C9.80521 14.9948 9.58242 14.6606 9.4981 14.2704C9.44218 14.1311 9.30282 14.0195 9.13595 14.0751C8.99659 14.1027 8.91315 14.2704 8.94067 14.4097C9.08003 14.8835 9.33034 15.3297 9.69337 15.6642C10.028 15.9428 10.4177 16.1654 10.8642 16.2774C10.9476 16.7232 10.8917 17.1411 10.7523 17.5036C10.5854 17.8662 10.3067 18.1724 9.9996 18.3956H9.97209C9.66586 18.6185 9.30282 18.7298 8.91316 18.7581C8.49509 18.7581 8.07702 18.6462 7.68646 18.3679V10.0058V9.97822H7.65895V9.9499H7.63143V9.92185H7.60302V9.89389H7.57551V9.86628L7.5471 9.83824L7.51959 9.81063L7.49207 9.78258V9.75498H7.46456V9.72693H7.43527V9.69933L7.40774 9.67128L7.37935 9.64332V9.61571H7.35183V9.58766H7.32342V9.56005L7.29591 9.53201V9.50405H7.26839V9.47635H7.23999V9.44839L7.21247 9.4207V9.39274H7.18496V9.36442H7.15655V9.33673L7.12904 9.30877V14.4653H7.10063C7.01719 14.4653 6.93376 14.4933 6.82281 14.4933C6.46066 14.4933 6.12513 14.3817 5.84731 14.2148H5.8189C5.51267 14.0472 5.26148 13.7966 5.09372 13.4896C5.01028 13.3504 4.84341 13.3227 4.70405 13.3783C4.5931 13.462 4.53717 13.6293 4.62061 13.7685C4.8434 14.1591 5.17715 14.4653 5.54019 14.6886L5.5686 14.7166C5.93075 14.9115 6.37722 15.0508 6.82281 15.0508C6.93376 15.0508 7.0456 15.0228 7.12904 15.0228V18.7019H7.01719C6.51657 18.7019 6.06921 18.5349 5.70795 18.2004C5.3458 17.8938 5.09372 17.42 5.01028 16.9184C4.98276 16.7512 4.84341 16.6673 4.70405 16.6673L4.64813 16.6956C4.20166 16.8348 3.78447 16.8348 3.39481 16.6956C3.08769 16.6116 2.80898 16.4167 2.58619 16.1933C2.36339 15.9705 2.19563 15.6919 2.08379 15.3574C1.94443 14.9391 1.91691 14.4933 2.08379 14.0195C2.1113 13.8802 2.02787 13.7129 1.88851 13.6572C1.44292 13.4897 1.13581 13.2111 0.913017 12.8489C0.71774 12.5703 0.606782 12.2358 0.579266 11.9009C0.550862 11.567 0.579266 11.2321 0.690218 10.8975C0.829575 10.5913 1.02486 10.2844 1.30357 10.0339C1.52725 10.3401 1.80508 10.5633 2.11131 10.7583C2.47435 10.9812 2.91993 11.0932 3.3664 11.0932C3.47824 11.0932 3.5892 11.0932 3.70104 11.0652C3.81199 11.0652 3.92383 11.0371 4.03478 11.0095C4.17414 10.9532 4.25846 10.8139 4.23006 10.6746C4.17414 10.5077 4.03479 10.4241 3.89543 10.4797C3.81199 10.4797 3.72855 10.5077 3.64512 10.5077C3.56168 10.5357 3.47824 10.5357 3.3664 10.5357C3.00336 10.5357 2.66962 10.452 2.39091 10.2844C2.08379 10.0895 1.83347 9.83824 1.6382 9.53201L1.61068 9.50405C1.35949 9.0582 1.27605 8.55633 1.35949 8.08252C1.41541 7.77567 1.52725 7.46944 1.72164 7.21851C1.88851 6.93997 2.11131 6.74434 2.39091 6.57738C2.78057 6.3545 3.22705 6.27115 3.70104 6.3268L3.72855 6.3545C4.11822 6.41015 4.48125 6.60507 4.75997 6.85627V6.88432C5.03868 7.13489 5.26148 7.4974 5.3458 7.8876C5.37332 8.02686 5.54019 8.11048 5.67955 8.08252C5.84731 8.05491 5.93075 7.8876 5.87483 7.74797C5.76299 7.24611 5.51268 6.80035 5.14964 6.46607H5.12212C4.81589 6.15922 4.42623 5.93625 3.97975 5.82494C3.86791 5.35104 3.92383 4.9051 4.11822 4.51472C4.28598 4.1523 4.53718 3.84599 4.87092 3.62266C5.17715 3.39995 5.56859 3.26068 5.95826 3.26068C6.12513 3.26068 6.29289 3.28856 6.48817 3.31643C6.54409 3.14929 6.62752 2.98162 6.71096 2.81465C6.46065 2.73113 6.20857 2.70326 5.93075 2.70326C5.42924 2.73113 4.95436 2.8704 4.56469 3.14929C4.14662 3.42774 3.81199 3.81811 3.61671 4.26414C3.39481 4.70973 3.31048 5.21195 3.39481 5.76902C2.91993 5.74097 2.50275 5.88059 2.11131 6.10357C1.77756 6.29884 1.47044 6.57738 1.24854 6.91192C1.02486 7.21851 0.885501 7.6087 0.802064 7.9989C0.71774 8.50068 0.774544 9.05819 1.02485 9.56005C0.6343 9.86628 0.356478 10.2844 0.189605 10.7026C0.0209562 11.1209 -0.034964 11.539 0.0209562 11.9565C0.0768765 12.3751 0.217114 12.7929 0.439907 13.1555C0.690217 13.546 1.02486 13.8802 1.47044 14.0751C1.35949 14.605 1.38789 15.1065 1.55477 15.5523C1.69412 15.9428 1.91692 16.305 2.19563 16.5835C2.47435 16.8905 2.83649 17.113 3.22704 17.2247C3.64511 17.3643 4.06229 17.3923 4.50966 17.3086C4.64813 17.8105 4.95436 18.2843 5.31651 18.6185C5.79139 19.0364 6.37721 19.2593 7.01719 19.2593C7.10063 19.2593 7.18496 19.2593 7.23999 19.2593C7.32343 19.2593 7.37935 19.2593 7.43527 19.2317C7.57551 19.2317 7.65895 19.1481 7.68646 19.0364C8.10453 19.2317 8.52349 19.3149 8.91316 19.3149C9.41378 19.2873 9.88865 19.12 10.2783 18.8694L10.3067 18.8418C10.7248 18.5626 11.0594 18.1724 11.2538 17.7269C11.4207 17.3086 11.505 16.8348 11.4491 16.333C11.9231 16.361 12.3687 16.2218 12.7592 15.9705C13.0939 15.7755 13.4001 15.5246 13.5954 15.1904C13.819 14.8835 13.9584 14.521 14.0418 14.1311C14.0978 13.6572 14.0418 13.1278 13.819 12.654C14.2087 12.347 14.4874 11.9565 14.6543 11.539C14.404 11.6226 14.1528 11.706 13.875 11.7896C13.7915 11.9289 13.6513 12.0402 13.5119 12.1521Z"
      fill="#0056D2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9617 4.90578C14.7674 5.24052 14.3487 5.65818 13.6794 6.1879C13.3452 6.4668 13.15 6.68938 13.0664 6.85702C12.9829 7.0243 12.9547 7.3309 12.9547 7.77634H11.5053C11.5053 7.55376 11.5053 7.44251 11.5053 7.38648C11.5053 6.9127 11.5898 6.55016 11.7296 6.24357C11.8958 5.93698 12.2028 5.60251 12.6768 5.21264C13.1227 4.8502 13.4006 4.59901 13.4842 4.48758C13.624 4.29278 13.7085 4.09735 13.7085 3.87458C13.7085 3.56772 13.5959 3.31716 13.3452 3.09384C13.0946 2.87117 12.7604 2.75974 12.3417 2.75974C11.924 2.75974 11.5898 2.87117 11.3101 3.09384C11.0594 3.34495 10.8651 3.67914 10.7534 4.15301L9.30307 3.95804C9.35937 3.28928 9.63908 2.73185 10.1676 2.25798C10.698 1.78411 11.3936 1.53292 12.2582 1.53292C13.1781 1.53292 13.9028 1.78411 14.4323 2.25798C14.9899 2.73185 15.2405 3.28927 15.2405 3.93015C15.2405 4.2649 15.157 4.59901 14.9617 4.90578ZM12.9547 9.89469H11.5053V8.30616H12.9547V9.89469ZM12.2863 -3.62396e-05C9.13688 -3.62396e-05 6.57227 2.56421 6.57227 5.71394C6.57227 8.89137 9.13688 11.4277 12.2863 11.4277C15.4358 11.4277 18.0004 8.89137 18.0004 5.71394C18.0004 2.56421 15.4358 -3.62396e-05 12.2863 -3.62396e-05Z"
      fill="#0056D2"
    />
  </svg>
);
